/* Copyright (C) Nicolas Lochet - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Nicolas Lochet <nicolas@lochet.com>, 2025
 */

export function defineGame (i18n) {
  i18n.game = {}
  i18n.game.common = {
    name: 'Nom&nbsp;:'
  }

  i18n.game.tabs = {
    map: 'Carte',
    inventory: 'Inventaire',
    exchange: 'Echanger',
    history: 'Historique'
  }

  i18n.game.map = {}

  i18n.game.map.tabs = {
    action: 'Action',
    people: 'Rencontre',
    settlement: 'Habitations',
    vehicle: 'Vehicules'
  }

  i18n.game.map.vehicle = {
    no_move_inland: 'Impossible de se déplacer à terre',
    name: 'Nom',
    type: 'Type',
    storage: 'Stockage',
    equipped: 'Equipement',
    occupants: {
      title: 'Présent à bord',
      header: {
        name: 'Nom',
        rank: 'Rang',
        teams: 'Equipes',
        leader: 'Leader',
        actions: 'Actions'
      }
    },
    empty: 'Vide',
    provide: 'Approsionner le chantier de construction',
    confirm_work: 'Souhaitez vous travailler sur ce chantier',
    new_build: 'Nouvelle construction',
    building_site: 'Construction en cours',
    ready: 'Véhicules à proximité',
    proposal: 'Ma contribution',
    onboard: (t, n) => `A bord du ${t} '${n}'`,
    info: (t, n) => `Information sur le ${t} '${n}'`,
    state: {
      title: 'Etape du chantier',
      advancement: 'Avancement',
      working: 'Travailleur En cours',
      tool: 'Outil requis',
      materials_next_step: 'Matériaux nécessaires pour la prochaine tranche de chantier',
      materials_to_finish: 'Matériaux nécessaires pour compléter le chantier'
    },
    transfer: {
      accept: 'Souhaitez-vous valider vos modifications ?',
      reset: 'Souhaitez-vous annuler vos modifications ?'
    },
    access: {
      own: 'Mon rang',
      view: 'Gérer les accès',
      not_member: 'Non membre',
      blacklisted: 'Accès refusé - Liste noire',
      member_count: 'Nombre de membre',
      name: 'Nom',
      rank: 'Rang',
      members: 'Membres',
      waiting_list: 'Liste d\'attente',
      blacklist: 'Liste noire',
      kick: (n) => `Voulez-vous débarquer de force "${n}" ?`,
      ask: {
        demand: 'Demander un accès',
        waiting: 'Demande en attente de validation',
        confirm: 'Souhaitez-vous demander un accès ?',
        accept: 'Souhaitez-vous accepter la demande d\'accès ?',
        reject: 'Souhaitez-vous rejeter la demande d\'accès ?',
        choose_rank: 'Choisissez un rang',
        change_rank_valid: (n, r) => `Validez vous le changement de rang de "${n}" en "${i18n.game.map.vehicle.access.ranks[r]}" ?`,
        blacklist: (n) => `Voulez-vous mettre "${n}" en liste noire ?`,
        unblacklist: (n) => `Voulez-vous sortir "${n}" de la liste noire ?`,
        remove: (n) => `Voulez-vous retirer "${n}" des membres ?`
      },
      ranks: {
        Owner: 'Propriétaire',
        Officer: 'Officier',
        Mate: 'Maistre',
        Crew: 'Equipage',
        Passenger: 'Passager'
      }
    },
    job: {
      join: 'Rejoindre une équipe',
      type: {
        drive: 'manoeuvre',
        fishing: 'pêche',
        //
        bake: 'cuisson du pain',
        install: 'installation',
        destroy: 'destruction',
        cultivate: 'culture',
        livestock: 'élevage'
      },
      type_target: {
        oven: 'four',
        cereal: 'céréale',
        linen: 'lin',
        fowl: 'faisan'
      },
      info: {
        title: 'Equipe de travail:',
        no_team: 'Pas d\'équipe de travail.'
      },
      team: {
        manage: 'Gérer les équipes de travail',
        see: 'Voir les équipes de travail',
        title: (n, t) => `Equipe de ${i18n.game.map.vehicle.job.type[n]}${t ? ` (${i18n.game.map.vehicle.job.type_target[t]})` : ''}`,
        lookup: (t) => t in i18n.game.map.vehicle.job.type ? i18n.game.map.vehicle.job.type[t] : t,
        join: 'Rejoindre', // (n) => `Joindre l'équipe de ${i18n.game.map.vehicle.job.type[n]}`,
        leave: 'Quitter', // (n) => `Quitter l'équipe de ${i18n.game.map.vehicle.job.type[n]}`,
        add: 'Ajouter un membre', // (n) => `Ajouter à l'équipe de ${i18n.game.map.vehicle.job.type[n]}`,
        no_team: 'Pas d\'équipe.'
      },
      drive: {
        not_leader: 'Vous n\'êtes pas en charge.',
        no_team: 'Pas d\'équipage.',
        current_team: (n) => `Equipage actuel: ${n}`,
        minimal_team: (n) => `Equipage minimal pour manoeuvrer: ${n}`,
        optimal_team: (n) => `Equipage optimal pour manoeuvrer: ${n}`,
        team_join: 'Rejoindre l\'équipage'
      },
      actions: {
        lookup: (t) => t in i18n.game.map.vehicle.job.type ? i18n.game.map.vehicle.job.type[t] : t,
        work: (t) => `Faire travailler l'équipe de ${i18n.game.map.vehicle.job.actions.lookup(t)}`,

        tool_required: (j, m) => `Equipement de ${i18n.game.map.vehicle.job.actions.lookup(j)} requis: ${i18n.game.item.lookup(m)}`,
        current_team: (j, c) => `Equipe de ${i18n.game.map.vehicle.job.actions.lookup(j)} actuelle: ${c}`,
        minimal_team: (j, m) => `Equipe de ${i18n.game.map.vehicle.job.actions.lookup(j)} minimale: ${m}`,
        optimal_team: (j, b) => `Equipe de ${i18n.game.map.vehicle.job.actions.lookup(j)} optimale: ${b}`
      }
    }
  }

  i18n.game.map.settlement = {
    ready: 'Habitations à proximité',
    inside: (t, n) => `À l'intérieur de ${i18n.game.construct.article.lookup(t)}${i18n.game.construct.lookup(t)} '${n}'`,
    info: (t, n) => `Information sur ${i18n.game.construct.article.lookup(t)}${i18n.game.construct.lookup(t)} '${n}'`,
    must_leave_to_move: 'Pour vous déplacer, vous devez d\u0027abord sortir de cette habitation.',
    storage: 'Stockage',
    empty: 'Vide',
    occupants: {
      title: 'Présents',
      header: {
        name: 'Nom',
        rank: 'Rang',
        teams: 'Equipes',
        actions: 'Actions'
      }
    },
    access: {
      kick: (n) => `Voulez-vous expulser "${n}" ?`
    },
    transfer: {
      accept: 'Souhaitez-vous valider vos modifications ?',
      reset: 'Souhaitez-vous annuler vos modifications ?'
    },
    job: {
      show: 'Afficher les travaux'
    },
    production: {
      growing: 'en croissance',
      waiting: 'prêt à travailler'
    },
    extensions: {
      buildings: 'Dépendances',
      tiles: 'Champs/Élevage',
      empty: 'Aucune',
      view: 'Voir',
      lookup: (t) => t in i18n.game.map.vehicle.job.type_target
        ? i18n.game.map.vehicle.job.type_target[t]
        : (t in i18n.game.item ? i18n.game.item[t] : t),
      status: {
        building: 'en construction',
        destroying: (i, n) => `en destruction (${i}/${n})`,
        install: (i, n) => `en construction (${i}/${n})`,
        ready: 'prêt'
      },
      farming: {
        plough: 'Prêt à labourer',
        weed: 'Prêt à désherber',
        sow: 'Prêt à semer',
        growth: 'En pousse',
        feed: 'En élevage',
        harvest: 'Prêt à récolter',
        slaughter: 'Prêt à abattre',
        breed: 'Prêt à reproduire',
        lookup: (name, prodStatus, phaseMode) => {
          const f = i18n.game.map.settlement.extensions.farming
          if (prodStatus === 'growing' || phaseMode === 'auto') {
            return f[name] ?? f.growth ?? name
          }
          return f[name] ?? name
        }
      },
      detail: {
        title: (n) => n,
        step: (n, total) => total ? `Étape ${n}/${total}` : `Étape ${n}`,
        phase: (n) => `Phase ${n}`,
        phaseProgress: (i, n) => `Phase ${i}/${n}`,
        stage: (n) => `Stade ${n}`,
        jobs: 'Travaux disponibles',
        no_jobs: 'Aucun travail disponible pour vous.'
      }
    }
  }

  i18n.game.objects = {
    tabs: {
      inventory: 'Inventaire',
      craft: 'Fabriquer'
    },
    bag: 'Sac',
    equipped: 'Equipement',
    tools: 'Outils',
    materials: 'Matériaux',
    food: 'Nourriture',
    vehicles: 'Vehicules',
    games: 'Gibiers',
    target: 'Cible',
    transform: {
      tool: 'Merci d\'équiper l\'outil'
    },
    bargain: {
      title: 'Trocs en cours',
      items: (content) => i18n.game.bargain.print_content(content)
    },
    working: {
      title: 'Utilisé par l\'action en cours',
      items: (content) => i18n.game.bargain.print_content(content)
    }
  }

  i18n.game.actions = {
    move: 'Déplacement',
    eat: 'Manger',
    no_actions: 'Aucune action possible ici.',
    collect: (r) => {
      if (['cereal', 'fruit', 'linen', 'vegetable'].includes(r)) {
        return i18n.game.actions.forage + ' ' + i18n.game.item.lookup(r)
      } else {
        return i18n.game.actions.pickup + ' ' + i18n.game.item.lookup(r)
      }
    },
    pickup: 'Ramasser',
    forage: 'Cueillir',
    using: 'avec',
    notool: 'sans outil',
    hunt: (a, b, c) => {
      if (['harpoon'].includes(a)) {
        return 'Pêcher au harpon'
      } else {
        return a !== b
          ? `Chasser avec ${i18n.game.item.lookup(a)} et ${i18n.game.item.lookup(b)} (${c})`
          : `Chasser avec ${i18n.game.item.lookup(a)}`
      }
    },
    craft: 'Fabriquer',
    build: {
      init: 'Ouvrir un chantier',
      see: 'Voir',
      access: 'Accéder au chantier',
      provide: 'Approvisionner',
      work: 'Construire'
    },
    vehicle: {
      embark: 'Embarquer',
      disembark: 'Débarquer',
      ask_embark: 'Souhaitez-vous embarquer ?',
      ask_disembark: 'Souhaitez-vous débarquer ?'
    },
    settlement: {
      enter: 'Entrer',
      leave: 'Sortir',
      ask_enter: 'Souhaitez-vous entrer ?',
      ask_leave: 'Souhaitez-vous sortir ?'
    },
    transform: 'Transformer',
    exchange: 'Echanger',
    equip: 'Equiper',
    unequip: 'Ranger'
  }

  i18n.game.doing = {
    move: ({ dir }) => `${i18n.game.actions.move} ${i18n.game.dir[dir]}`,
    'Job.drive.lead': ({ dir }) => `Dirige la manoeuvre vers ${i18n.game.dir.article_le(dir)}${i18n.game.dir[dir]}`,
    'Job.drive.work': ({ dir }) => `Participe à la manoeuvre vers ${i18n.game.dir.article_le(dir)}${i18n.game.dir[dir]}`,
    collect: ({ r }) => {
      if (['cereal', 'fruit', 'linen', 'vegetable'].includes(r)) {
        return i18n.game.actions.forage + ' ' + i18n.game.item.lookup(r)
      } else {
        return i18n.game.actions.pickup + ' ' + i18n.game.item.lookup(r)
      }
    },
    hunt: (o) => {
      if (['harpoon', 'fishing_net'].includes(o.w)) return `Pêcher au ${i18n.game.item.lookup(o.w)}`
      else return `Chasser à ${o.w === 'bow' ? 'l\'' : 'la '}${i18n.game.item.lookup(o.w)}`
    },
    'Job.cultivate.lead': ({ c }) => `Dirige la culture sur '${c}'`,
    'Job.cultivate.work': ({ c }) => `Participe à la culture sur '${c}'`,
    'Job.livestock.lead': ({ c }) => `Dirige l'élevage sur '${c}'`,
    'Job.livestock.work': ({ c }) => `Participe à l'élevage sur '${c}'`,
    'Job.bake.lead': ({ c }) => `Dirige la cuisson du pain sur '${c}'`,
    'Job.bake.work': ({ c }) => `Participe à la cuisson du pain sur '${c}'`
  }
  i18n.game.withTool = (x) => `avec ${x}`
  i18n.game.item = {
    lookup: (t) => t in i18n.game.item ? i18n.game.item[t] : t,
    present: (e) => i18n.game.item.lookup(e.t) + ('n' in e ? ` (${e.n})` : ''),
    axe: 'hache',
    arrow: 'flèche',
    bucket: 'seau',
    bow: 'arc',
    bread: 'pain',
    cereal: 'céréale',
    dough: 'pâton',
    duck: 'canard',
    egg: 'oeufs',
    feather: 'plume',
    fish: 'poisson',
    fruit: 'fruit',
    fowl: 'faisan',
    fishing_net: 'filet de pêche',
    grinder: 'meule',
    harpoon: 'harpon',
    hoe: 'houe',
    javelin: 'javelot',
    knife: 'couteau',
    linen: 'lin',
    meat: 'viande',
    pan: 'poêle',
    pebble: 'galet',
    pelt: 'fourrure',
    rabbit: 'lapin',
    reed: 'roseau',
    scythe: 'faux',
    sling: 'fronde',
    stone: 'roche',
    string: 'corde',
    vegetable: 'légume',
    waterskin: 'outre',
    wood: 'bois',
    none: 'aucun'
  }

  i18n.game.construct = {
    lookup: (t) => t in i18n.game.construct.type ? i18n.game.construct.type[t] : t,
    type: {
      canoe: 'canoe',
      sailboat: 'voilier',
      farm: 'ferme',
      port: 'port'
    },
    article: {
      lookup: (t) => t in i18n.game.construct.article.type ? i18n.game.construct.article.type[t] : t,
      type: {
        canoe: 'le ',
        sailboat: 'le ',
        farm: 'la ',
        port: 'le '
      }
    },
    build_stage: {
      lookup: (t) => t in i18n.game.construct.build_stage ? i18n.game.construct.build_stage[t] : t,
      // canoe, sailboat
      frame: 'ossature',
      hull: 'coque',
      keel: 'quille',
      spars: 'espars',
      sails: 'voiles',
      // farm
      foundation: 'fondations',
      dome: 'dôme',
      framework: 'charpente',
      wall: 'murs',
      roof: 'toiture',
      // port
      jetty: 'jetée',
      quay: 'quai',
      pontoon: 'ponton'
    },
    state: {
      current_stage_finishing: 'Finalisation de l\'étape en cours...'
    }
  }

  i18n.game.dir = {
    N: 'Nord',
    NE: 'Nord-Est',
    E: 'Est',
    SE: 'Sud-Est',
    S: 'Sud',
    SW: 'Sud-Ouest',
    W: 'Ouest',
    NW: 'Nord-Ouest',
    article_le: (d) => ['E', 'W'].includes(d) ? 'l\'' : 'le ',
    article_de: (d) => ['E', 'W'].includes(d) ? 'd\'' : 'de '
  }

  i18n.game.exchange = {
    none: 'Aucune conversation.',
    new: 'Inconnus',
    chat: 'Discuter',
    add: 'Ajouter',
    known: 'Conversations',
    unread: 'Non lu :'
  }

  i18n.game.chat = {
    with_members: 'Conversation avec : '
  }

  i18n.game.bargain = {
    title: (char) => `Troc avec ${char.name}`,
    other_proposal: 'Sa proposition',
    my_proposal: 'Ma proposition',
    my_bag: () => 'Disponible à l\'échange',
    is_open: 'Transaction ouverte aux modifications',
    locked_by_me: 'Transaction fermée aux modifications&nbsp;: acceptée par vous',
    locked_by_other: (char) => `Transaction fermée aux modifications&nbsp;: acceptée par ${char.name}`,
    more_than_zero: 'Selectionnez une quantité supérieur à zéro.',
    empty: 'Vide',
    add: 'Ajouter',
    remove: 'Retirer',
    propose: 'Proposer',
    edit: 'Modifier',
    send: 'Envoyer',
    reset: 'Reinitialiser',
    unlock: 'Réouvrir',
    accept: 'Valider',
    cancel: 'Annuler',
    confirm_bargain_accepted: 'Souhaitez-vous accepter cette transaction ?',
    confirm_bargain_rejected: 'Souhaitez-vous annuler cette transaction ?',
    confirm_edit_proposal: 'Souhaitez-vous modifier votre proposition ?',
    confirm_send_proposal: 'Souhaitez-vous envoyer votre nouvelle proposition ?',
    confirm_unlock_proposal: 'En envoyant cette proposition, vous réouvrez la transaction.',
    confirm_reset_proposal: 'Souhaitez-vous annuler vos dernières modifications ?',

    change_in_bargain: 'Un changement dans votre proposition de troc est intervenu par une autre connection, nous devons reinitialiser vos modification non envoyées.',
    change_in_bag: 'Un changement est intervenu dans le contenu de votre sac, nous devons reinitialiser vos modification non envoyées.',
    me: 'moi',
    unknown: 'inconnu',
    format_message: (b, who, isSelf) => {
      switch (b.t) {
        case 'o':
          return i18n.game.bargain.chat.open(who)
        case 'u':
          return i18n.game.bargain.chat.update(who, b.received)
        case 'r':
          return i18n.game.bargain.chat.reopen(who)
        case 'a':
          return i18n.game.bargain.chat.accept(who)
        case 'c':
          return i18n.game.bargain.chat.close(who, isSelf, b)
        case 'x':
          return i18n.game.bargain.chat.cancel(who)
        default:
          return `${b.t}: ${b.bi}`
      }
    },
    chat: {
      propal: 'Proposition d\'échange',
      open: (who) => `${i18n.game.bargain.chat.propal} <b>ouverte</b> par ${who}`,
      update: (who) => `${i18n.game.bargain.chat.propal} <b>mise à jour</b> par ${who}`,
      reopen: (who) => `${i18n.game.bargain.chat.propal} <b>débloquée</b> par ${who}`,
      accept: (who) => `${i18n.game.bargain.chat.propal} <b>acceptée</b> par ${who}`,
      cancel: (who) => `${i18n.game.bargain.chat.propal} <b>rejetée</b> par ${who}`,
      close: (who, isSelf, b) => isSelf
        ? `Echange conclue avec ${who}.<br> Donné : ${i18n.game.bargain.print_content(b.given)}.<br> Reçu : ${i18n.game.bargain.print_content(b.received)}.`
        : `Echange conclue par ${who}.<br> Donné : ${i18n.game.bargain.print_content(b.received)}.<br> Reçu : ${i18n.game.bargain.print_content(b.given)}.`
    },
    print_content: (what) => `${what.length > 0 ? what.map(i18n.game.item.present).join(', ') : '--rien--'}`
  }

  i18n.game.history = {
    present: (l, p) => {
      const prefix = l.split('.')[0]
      if (prefix in i18n.game.history) {
        if (typeof i18n.game.history[prefix] === 'function') {
          return i18n.game.history[prefix](l, p)
        } else if (l in i18n.game.history[prefix]) {
          if (typeof i18n.game.history[prefix][l] === 'function') {
            return i18n.game.history[prefix][l](p)
          } else {
            return i18n.game.history[prefix][l]
          }
        } else {
          return `+-- ${l}: ${p.map(JSON.stringify).join(', ')}`
        }
      } else {
        return `--- ${l}: ${p.map(JSON.stringify).join(', ')}`
      }
    },
    character: {
      'character.eat.complete': ([p]) => `Mange ${i18n.game.item.present(p)}`,
      'character.equip.item': ([p]) => `Equipe ${i18n.game.item.present(p)}`,
      'character.unequip.item': ([p]) => `Range ${i18n.game.item.present(p)}`
    },
    bargain: {
      'bargain.send.open.to': ([, , who]) => `Proposition de troc ouverte avec ${who}.`,
      'bargain.receive.open.from': ([, , who]) => `Proposition de troc ouverte par ${who}.`,
      'bargain.send.update.content.to': ([content, , who]) => `Proposition de troc mise à jour avec ${who} : ${i18n.game.bargain.print_content(content)}.`,
      'bargain.receive.update.content.from': ([content, , who]) => `Proposition de troc mise à jour par ${who} : ${i18n.game.bargain.print_content(content)}.`,
      'bargain.send.accept.to': ([, , who]) => `Proposition de troc acceptée avec ${who}.`,
      'bargain.receive.accept.from': ([, , who]) => `Proposition de troc acceptée par ${who}.`,
      'bargain.send.cancel.to': ([, , who]) => `Proposition de troc rejetée avec ${who}.`,
      'bargain.receive.cancel.from': ([, , who]) => `Proposition de troc rejetée par ${who}.`,
      'bargain.send.reopen.to': ([, , who]) => `Proposition de troc débloquée par ${who}.`,
      'bargain.receive.reopen.from': ([, , who]) => `Proposition de troc débloquée par ${who}.`,
      'bargain.send.accept.finalize.to': ([given, received, , who]) => `Proposition de troc conclue avec ${who}.<br> Donné : ${i18n.game.bargain.print_content(given)}.<br> Reçu : ${i18n.game.bargain.print_content(received)}.`,
      'bargain.receive.accept.finalize.from': ([given, received, , who]) => `Proposition de troc conclue par ${who}.<br> Donné : ${i18n.game.bargain.print_content(given)}.<br> Reçu : ${i18n.game.bargain.print_content(received)}.`
    },
    collect: {
      'collect.success': ([p]) => {
        const r = { ...p }
        const { tool } = r
        delete r.tool
        return `Ramassage de ${Object.entries(r).map(([t, n]) => i18n.game.item.present({ t, n }))}${tool !== 'none' ? ` avec ${i18n.game.item.lookup(tool)}` : ''}`
      },
      'collect.failure': ([p]) => {
        const r = { ...p }
        const { tool } = r
        delete r.tool
        return `Echec du ramassage de ${Object.entries(r).map(([t]) => i18n.game.item.lookup(t))}${tool !== 'none' ? ` avec ${i18n.game.item.lookup(tool)}` : ''}`
      }
    },
    hunt: {
      'hunt.success': ([p]) => {
        const r = { ...p }
        delete r.kill
        const { res } = r
        delete r.res
        const prises = Object.entries(res).map(([k, n]) => i18n.game.item.lookup(k) + ' (' + n + ')')
        const pertes = Object.entries(r).filter(([, n]) => n > 0).map(([t, n]) => i18n.game.item.present({ t, n }))
        return `Chasse réussie. Prises: ${prises.join(', ')}.${pertes.length > 0 ? ` Pertes : ${pertes.join(', ')}.` : ''}`
      },
      'hunt.failure': ([r]) => {
        const pertes = Object.entries(r).filter(([, n]) => n > 0).map(([t, n]) => i18n.game.item.present({ t, n }))
        return `Chasse infructueuse.${pertes.length > 0 ? ` Pertes : ${pertes.join(', ')}.` : ''}`
      }
    },
    transform: {
      'transform.success': ([r]) => `Transformation de ${Object.entries(r).map(([k, v]) => i18n.game.item.lookup(k) + ' en ' + Object.entries(v).map(([t, n]) => i18n.game.item.present({ t, n })).join(', '))}`,
      'transform.failure': ([r]) => `Echec de transformation de ${Object.entries(r).map(([k, v]) => i18n.game.item.lookup(k) + ' en ' + Object.entries(v).map(([t, n]) => i18n.game.item.present({ t, n })).join(', '))}`
    },
    craft: {
      'craft.success': ([res, from]) => `Fabrication de ${Object.entries(res).map(([t, n]) => i18n.game.item.present({ t, n })).join(', ')} avec ${from.map(i18n.game.item.present).join(', ')}`,
      'craft.failure': ([res, from]) => `Echec de fabrication de ${Object.entries(res).map(([t, n]) => i18n.game.item.present({ t, n })).join(', ')} avec ${from.map(i18n.game.item.present).join(', ')}`
    },
    build: {
      'build.provide.content': ([given]) => `Approvisionnement du chantier: ${i18n.game.bargain.print_content(given)}`,
      'build.stage.complete': ([{ target, stage, name }]) => `Etape de construction '${i18n.game.build_stage.lookup(stage)}' sur le ${target} "${name}"`
    },
    move: {
      'move.complete': ([d]) => `Déplacement vers ${i18n.game.dir.article_le(d)}${i18n.game.dir[d]}`
    },
    vehicle: {
      'vehicle.embark': ([, n]) => `Embarquement à bord de "${n}"`,
      'vehicle.disembark': ([, n]) => `Débarquement de "${n}"`,
      'vehicle.drive.complete': ([d, n]) => `Déplacement de "${n}" vers ${i18n.game.dir.article_le(d)}${i18n.game.dir[d]}`,
      'vehicle.transfer.bag': ([{ add, del }]) => 'Transfert:' +
          (
            add && add.length > 0
              ? `<br>Vers le sac :"${i18n.game.bargain.print_content(add)}"`
              : ''
          ) +
          (
            del && del.length > 0
              ? `<br>Vers la cale :"${i18n.game.bargain.print_content(del)}"`
              : ''
          ),
      'vehicle.kick.out': ([, n, t,, c]) => `Vous avez débarqué de force "${c}" du ${t} "${n}"`,
      'vehicle.equip.item': ([p, n]) => `Equipement de '${i18n.game.item.present(p)}' sur '${n}'`,
      'vehicle.unequip.item': ([p, n]) => `Rangement de '${i18n.game.item.present(p)}' sur '${n}'`
    },
    access: {
      'access.ask': ([, t, n]) => `Demande d'accès au ${t} "${n}".`,
      'access.accept': ([, t, n, b]) => `Accès accordé par "${b}" au ${t} "${n}".`,
      'access.reject': ([, t, n, b, x]) => `Accès rejeté par "${b}" au ${t} "${n}"${x ? ' (et mise en liste noire)' : ''}.`,
      'access.remove': ([, t, n, b]) => `Accès retiré par "${b}" au ${t} "${n}".`,
      'access.blacklist': ([, t, n, b]) => `Mise en liste noire par "${b}" sur le ${t} "${n}".`,
      'access.unblacklist': ([, t, n, b]) => `Retrait de la liste noire par "${b}" sur le ${t} "${n}".`,
      'access.change-rank': ([, t, n, b, o, r]) => `Rang pour le ${t} "${n}" changer de "${i18n.game.map.vehicle.access.ranks[o]}" à "${i18n.game.map.vehicle.access.ranks[r]}" par "${b}"`

    },
    skill_rx: /^skill\.(.*)\.level\.up$/,
    skill_type: {
      lookup: (t) => t in i18n.game.history.skill_type ? i18n.game.history.skill_type[t] : t,

      collect: 'Ramassage/Cueillette',
      'collect.wood': 'Ramassage du bois',
      'collect.linen': 'Ramassage du lin',
      'collect.fruit': 'Cueillette de fruits',
      'collect.pebble': 'Ramassage de galets',
      'collect.reed': 'Ramassage de roseaux',
      'collect.stone': 'Ramassage de roche',
      'collect.egg': 'Ramassage d\'oeuf',

      hunt: 'Chasse/Pêche',
      'hunt.sling': 'Chasse à la fronde',
      'hunt.bow': 'Chasse à l\'arc',
      'hunt.harpoon': 'Pêche au harpon',

      craft: 'Fabrication',
      'craft.string': 'Fabrication de cordage',
      'craft.arrow': 'Fabrication de flèche',
      'craft.pebble': 'Fabrication de galet',

      transform: 'Transformation',
      'transform.rabbit': 'Transformation de lapin',
      'transform.duck': 'Transformation de canard',
      'transform.fowl': 'Transformation de faisan'
    },
    skill: (l, [p]) => {
      const s = l.replace(i18n.game.history.skill_rx, ($0, $1) => $1)
      // TODO inspect this code
      if (i18n.game.history.skill_type.lookup(s) === s) console.log(s, p, i18n.game.history.skill_rx.test(l))
      return `Progression au niveau ${p} en ${i18n.game.history.skill_type.lookup(s)}`
    },
    team: {
      'team.join': ([, n, t, j, i]) => `Rejoint l'équipe '${i18n.game.map.vehicle.job.type[j]}${i ? '-' + i : ''}' sur ${t} ${n}`,
      'team.leave': ([, n, t, j, i]) => `Quitte l'équipe '${i18n.game.map.vehicle.job.type[j]}${i ? '-' + i : ''}' sur ${t} ${n}`,

      'team.add.lead': ([, n, t, j, i, b]) => `Ajoute ${b} de l'équipe '${i18n.game.map.vehicle.job.type[j]}${i ? '-' + i : ''}' sur ${t} ${n}`,
      'team.add.by': ([, n, t, j, i, b]) => `Ajouté par ${b} de l'équipe '${i18n.game.map.vehicle.job.type[j]}${i ? '-' + i : ''}' sur ${t} ${n}`,

      'team.remove.lead': ([, n, t, j, i, b]) => `Retire ${b} de l'équipe '${i18n.game.map.vehicle.job.type[j]}${i ? '-' + i : ''}' sur ${t} ${n}`,
      'team.remove.by': ([, n, t, j, i, b]) => `Retiré par ${b} de l'équipe '${i18n.game.map.vehicle.job.type[j]}${i ? '-' + i : ''}' sur ${t} ${n}`,

      'team.leader.lead': ([, n, t, j, i, _, b, s]) => `Commandement ${s ? 'donné' : 'retiré'} à ${b} pour l'équipe '${i18n.game.map.vehicle.job.type[j]}${i ? '-' + i : ''}' sur ${t} ${n}`,
      'team.leader.by': ([, n, t, j, i, _, b, s]) => `Commandement ${s ? 'donné' : 'retiré'} par ${b} pour l'équipe '${i18n.game.map.vehicle.job.type[j]}${i ? '-' + i : ''}' sur ${t} ${n}`
    },
    job: {
      'job.fishing.success': ([p]) => {
        const r = { ...p }
        delete r.kill
        const { res } = r
        delete r.res
        const prises = Object.entries(res).map(([k, n]) => i18n.game.item.lookup(k) + ' (' + n + ')')
        const pertes = Object.entries(r).filter(([, n]) => n > 0).map(([t, n]) => i18n.game.item.present({ t, n }))
        return `Pêche réussie. Prises: ${prises.join(', ')}.${pertes.length > 0 ? ` Pertes : ${pertes.join(', ')}.` : ''}`
      },
      'job.fishing.failure': ([r]) => {
        const pertes = Object.entries(r).filter(([, n]) => n > 0).map(([t, n]) => i18n.game.item.present({ t, n }))
        return `Pêche infructueuse.${pertes.length > 0 ? ` Pertes : ${pertes.join(', ')}.` : ''}`
      }
    },
    teleport: {
      'teleport.complete': 'Téléportation...'
    }
  }

  i18n.game.invalid = {
    'character.eat.not.available': () => 'Impossible de manger, le personnage est déjà occupé.',
    'collect.start.character.not.available': () => 'Ramassage/Cueillette impossible, le personnage est déjà occupé.',
    'craft.start.character.not.available': () => 'Fabrication impossible, le personnage est déjà occupé.',
    'hunt.start.character.not.available': () => 'Chasse/Pêche impossible, le personnage est déjà occupé.',
    'move.start.character.not.available': () => 'Déplacement impossible, le personnage est déjà occupé.',
    'transform.start.character.not.available': () => 'Transformation impossible, le personnage est déjà occupé.',

    'character.unequip.cannot.working.with': ([p]) => `Impossible de ranger un outil en cours d'usage: "${i18n.game.item.lookup(p.t)}"`,

    'collect.start.character.has.not.enough.energy': () => 'Ramassage/Cueillette impossible, votre personnage manque d\'énergie.',
    'collect.start.equipped.does.not.have.tool': ([tool]) => `Ramassage/Cueillette impossible, outil manquant: ${i18n.game.item.lookup(tool.t ?? tool)}.`,
    'craft.start.character.has.not.enough.energy': () => 'Fabrication impossible, votre personnage manque d\'énergie.',
    'hunt.start.character.has.not.enough.energy': () => 'Chasse/Pêche impossible, votre personnage manque d\'énergie.',
    'move.start.character.has.not.enough.energy': () => 'Déplacement impossible, votre personnage manque d\'énergie.',
    'transform.start.character.has.not.enough.energy': () => 'Transformation impossible, votre personnage manque d\'énergie.',

    'move.start.target.terrain.invalid': ([d]) => `Déplacement impossible vers ${i18n.game.dir.article_le(d)}${i18n.game.dir[d]}`,
    'move.start.target.coord.should.not.be.identical': () => 'Déplacement sur place impossible.',

    'move.start.character.not.outside': () => 'Déplacement impossible quand embarqué',

    'craft.start.equipped.does.not.have.tool': ([t, , tool]) => `Fabrication de "${i18n.game.item.lookup(t)}" impossible un outil est nécessaire: ${i18n.game.item.lookup(tool)}`,
    'craft.start.bag.does.not.have.material': ([t, , , o]) => `Fabrication de "${i18n.game.item.lookup(t)}" impossible, matériau manquant dans le sac: ${i18n.game.item.present(o)}`,
    'craft.start.item.must.be.in.bag': ([t, , , o]) => `Fabrication de "${i18n.game.item.lookup(t)}" impossible, déplacez d'abord dans le sac: ${i18n.game.item.present(o)}`,
    'craft.start.cannot.with.bargained.item': ([t, , , o, b, n]) => `Fabrication de "${i18n.game.item.lookup(t)}" impossible car un élément est inclus dans ${b === 1 ? 'une transaction' : b + ' transactions'}: ${i18n.game.item.present(o)}`,

    'transform.start.equipped.does.not.have.tool': ([tool]) => `Transformation impossible, outil manquant: ${i18n.game.item.lookup(tool.t ?? tool)}.`,
    'transform.start.material.must.be.moved.in.bag': ([item]) => `Transformation impossible, rangez d'abord dans le sac: ${i18n.game.item.present(item)}`,
    'transform.start.bag.does.not.have.item': ([item]) => `Transformation impossible, objet absent du sac: ${i18n.game.item.present(item)}`,
    'transform.start.cannot.with.bargained.item': ([item, , , o, b]) => `Transformation de "${i18n.game.item.lookup(item.t ?? item)}" impossible car un élément est inclus dans ${b === 1 ? 'une transaction' : b + ' transactions'}: ${i18n.game.item.present(o)}`,

    'bargain.accept.must.be.on.same.coord': () => 'Acceptation de troc possible uniquement si les participants sont au même endroi.',
    'bargain.accept.cannot.do.if.already.accepted.by.oneself': ([other]) => `Vous avez déjà accepté ce troc. Attendez la réponse de ${other}.`,

    'build.storage.does.not.have.material': ([, k]) => `Materiaux de construction indisponible: ${i18n.game.item.lookup(k)}`,
    'build.storage.does.not.have.enough.material': ([, k, i, n]) => `Materiaux de construction insuffisant: ${i18n.game.item.lookup(k)} (${i}/${n}) `,

    'build.init.name.empty': () => 'Impossible de démarrer un chantier : le nom est vide.',
    'build.init.character.not.available': () => 'Impossible de démarrer un chantier, le personnage est déjà occupé.',
    'build.invalid.location': () => 'Emplacement invalide pour ce chantier.',
    'build.invalid.settlement.already.exists.here': () => 'Un lieu d\'habitation existe déjà à cet endroit.',
    'build.invalid.settlement.already.exists.in_radius': () => 'Un lieu d\'habitation existe déjà trop près.',
    'build.invalid.infrastructure.already.exists.here': ([t]) => `${i18n.game.construct.article.lookup(t)}${i18n.game.construct.lookup(t)} existe déjà à cet endroit.`,
    'build.invalid.infrastructure.already.exists.in_radius': ([t]) => `${i18n.game.construct.article.lookup(t)}${i18n.game.construct.lookup(t)} existe déjà trop près.`,
    'build.invalid.get.stage.name': ([stage]) => `Étape de construction inconnue : "${stage}".`,
    'build.invalid.is.last.stage.name': ([stage]) => `Étape "${i18n.game.construct.build_stage.lookup(stage)}" : erreur interne (dernière étape).`,
    'build.invalid.next.stage.name': ([stage]) => `Étape "${i18n.game.construct.build_stage.lookup(stage)}" : pas d'étape suivante.`,
    'build.invalid.stage': ([stage]) => `Impossible de travailler sur l'étape "${i18n.game.construct.build_stage.lookup(stage)}" : ce n'est pas l'étape en cours.`,
    'build.invalid.stage.construct': ([s]) => {
      const stage = s?.state?.stage?.name ?? s?.stage?.name
      return stage
        ? `L'étape en cours est "${i18n.game.construct.build_stage.lookup(stage)}", pas celle demandée.`
        : 'L\'étape demandée ne correspond pas à l\'étape en cours du chantier.'
    },
    'build.invalid.stage.construct.already.finished': ([s]) => {
      const stage = s?.state?.stage?.name ?? s?.stage?.name
      return stage
        ? `L'étape "${i18n.game.construct.build_stage.lookup(stage)}" est déjà terminée.`
        : 'Cette étape de construction est déjà terminée.'
    },
    'build.invalid.stage.construct.stage.step.complete': () => 'Impossible de démarrer cette étape : tous les créneaux de travail sont déjà occupés.',
    'build.from.not.defined': ([k]) => `Matériau de construction non défini : ${i18n.game.item.lookup(k)}.`,
    'build.target.not.defined': ([t]) => `Type de construction non défini : ${t}.`,
    'build.status.set.invalid.status': ([status]) => `Statut de chantier invalide : ${status}.`,

    'build.provide.character.cannot.access': () => 'Apport de matériaux impossible : accès refusé au chantier.',
    'build.provide.character.not.available': () => 'Apport de matériaux impossible, le personnage est déjà occupé.',
    'build.provide.content.cannot.be.empty': () => 'Apport de matériaux impossible : rien à déposer.',
    'build.provide.cannot.if.equipped': ([items]) => `Apport impossible : retirez d'abord l'objet équipé (${items.map(i18n.game.item.present).join(', ')}).`,
    'build.provide.cannot.if.not.enough.in.bag': ([items]) => `Apport impossible, quantité insuffisante dans le sac : ${items.map(i18n.game.item.present).join(', ')}.`,

    'job.cultivate.tool.not.equipped': ([tool]) => `${i18n.game.map.vehicle.job.actions.lookup('cultivate')} impossible, outil manquant : ${i18n.game.item.lookup(tool)}.`,
    'job.cultivate.getFrom.not.enough': ([itemType, qty]) => `${i18n.game.map.vehicle.job.actions.lookup('cultivate')} impossible, ${i18n.game.item.lookup(itemType)} insuffisant (${qty} requis).`,
    'job.livestock.tool.not.equipped': ([tool]) => `${i18n.game.map.vehicle.job.actions.lookup('livestock')} impossible, outil manquant : ${i18n.game.item.lookup(tool)}.`,
    'job.install.tool.not.equipped': ([tool]) => `${i18n.game.map.vehicle.job.actions.lookup('install')} impossible, outil manquant : ${i18n.game.item.lookup(tool)}.`,
    'job.install.getFrom.not.enough': ([itemType, qty]) => `${i18n.game.map.vehicle.job.actions.lookup('install')} impossible, ${i18n.game.item.lookup(itemType)} insuffisant (${qty} requis).`,
    'job.destroy.tool.not.equipped': ([tool]) => `${i18n.game.map.vehicle.job.actions.lookup('destroy')} impossible, outil manquant : ${i18n.game.item.lookup(tool)}.`,
    'job.bake.getFrom.fuel.not.found': ([fuel]) => `${i18n.game.map.vehicle.job.actions.lookup('bake')} impossible, combustible manquant dans le stock : ${i18n.game.item.lookup(fuel)}.`,
    'job.bake.getFrom.fuel.not.enough': ([fuel, qty]) => `${i18n.game.map.vehicle.job.actions.lookup('bake')} impossible, ${i18n.game.item.lookup(fuel)} insuffisant (${qty} requis).`,
    'job.bake.getFrom.from.not.found': ([itemType]) => `${i18n.game.map.vehicle.job.actions.lookup('bake')} impossible, matière manquante dans le stock : ${i18n.game.item.lookup(itemType)}.`,
    'job.bake.getFrom.from.not.enough': ([itemType]) => `${i18n.game.map.vehicle.job.actions.lookup('bake')} impossible, ${i18n.game.item.lookup(itemType)} insuffisant.`,
    'job.bake.check.from.not.found': () => `${i18n.game.map.vehicle.job.actions.lookup('bake')} impossible, matériaux manquants dans le stock.`,

    'build.start.character.cannot.access': ([, n]) => `Participation au chantier "${n}" impossible : accès refusé.`,
    'build.start.character.not.available': () => 'Participation au chantier impossible, le personnage est déjà occupé.',
    'build.start.character.not.at.construct': ([, n]) => `Participation au chantier "${n}" impossible : vous devez être sur place.`,
    'build.start.character.rank.not.sufficient': ([, n, r]) => `Rang "${i18n.game.map.vehicle.access.ranks[r]}" insuffisant pour participer au chantier de "${n}"`,

    'build.done.is.not.worker': () => 'Erreur interne : fin de chantier réservée au worker.',
    'build.done.is.not.finished': ([stage, constructId]) => `Erreur interne : travail non terminé (étape ${stage}, chantier ${constructId}).`,

    'vehicle.disembark.must.be.on.land': () => 'Vous devez être à terre pour débarquer',
    'vehicle.embark.character.cannot.access': ([, n]) => `Embarquement impossible sur "${n}": Accès refusé.`,

    'vehicle.move.target.terrain.invalid': ([d]) => `Déplacement impossible vers ${i18n.game.dir.article_le(d)}${i18n.game.dir[d]}`,
    'vehicle.move.character.rank.not.sufficient': ([, t, r]) => `Rang "${i18n.game.map.vehicle.access.ranks[r]}" insuffisant pour conduire le ${t}.`,

    'vehicle.kick.must.be.on.land': () => 'Vous devez être à terre pour débarquer',
    'vehicle.kick.character.rank.not.sufficient': ([, r, n, s]) => `Rang "${i18n.game.map.vehicle.access.ranks[r]}" insuffissant: Impossible de débarquer de force "${n}" de rang "${i18n.game.map.vehicle.access.ranks[s]}"`
  }
}
